import { styled } from '@mui/system'
import { DataGrid } from '@mui/x-data-grid'

export const UsersTablePaper = styled('div')(() => ({
  height: 350,
  width: 792,
  '& .MuiDataGrid-row': {
    cursor: 'pointer',
  },
}))

export const UsersTableActionButton = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'left',
}))

export const UsersTableDataGrid = styled(DataGrid)(() => ({
  overflowX: 'auto',
  '& .MuiDataGrid-columnHeaderTitle': {
    color: 'white',
  },
  '& .MuiDataGrid-columnHeaderTitleContainer': {
    display: 'flex',
    justifyContent: 'center',
  },
}))
